import { GetResponseInterface } from "../../interfaces/ActionReducer/GetMethod/GetResponse";
import { GetRequestInterface } from "../../interfaces/ActionReducer/GetMethod/GetRequest";
import { GeometryPointInterface } from "../../interfaces/Geometry";
import { GetRequestWithoutLimitOffset } from "interfaces/ActionReducer/GetMethod/GetRequestWithoutLimitOffset";
import { Scenario } from "../../components/curb/ManagerAnalyzer/Manager/SelectScenarios/helpers";
import { GeoserverAssetRootObject } from "../../interfaces/Geoserver";
import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

export const GET_ASSET_DATA = "GET_ASSET_DATA";
export const GET_ASSET_CONFIG_DATA = "GET_ASSET_CONFIG_DATA";
export const RECEIVED_ASSET_DATA = "RECEIVED_ASSET_DATA";
export const RECEIVED_ASSET_CONFIG_DATA = "RECEIVED_ASSET_CONFIG_DATA";
export const RECEIVED_POLYGON_ASSET_DATA = "RECEIVED_POLYGON_ASSET_DATA";
export const RECEIVED_DEFAULT_POLYGON_ASSET_DATA = "RECEIVED_DEFAULT_POLYGON_ASSET_DATA";
export const RECEIVED_SEGMENT_ASSET_DATA = "RECEIVED_SEGMENT_ASSET_DATA";
export const STORE_ENABLED_ASSET_IDS = "STORE_ENABLED_ASSET_IDS";
export const SELECTED_ASSET_COLUMNS = "SELECTED_ASSET_COLUMNS";

/* Edit Asset Types Start */
export const ASSET_LIST_VIEW_ATTRIBUTES_RECEIVED = "ASSET_LIST_VIEW_ATTRIBUTES_RECEIVED";
export const DELETE_PROPOSED_ASSETS = "DELETE_PROPOSED_ASSETS";
export const EDIT_ASSET_FORM_DATA_RECEIVED = "EDIT_ASSET_FORM_DATA_RECEIVED";
export const GET_ASSET_LIST_VIEW_ATTRIBUTES = "GET_ASSET_LIST_VIEW_ATTRIBUTES";
export const GET_EDIT_ASSET_FORM_DATA = "GET_EDIT_ASSET_FORM_DATA";
export const GET_PROPOSED_ASSETS = "GET_PROPOSED_ASSETS";
export const GET_ASSETS = "GET_ASSETS";
export const POST_EDIT_ASSET_DATA = "POST_EDIT_ASSET_DATA";
export const PUBLISH_PROPOSED_ASSETS = "PUBLISH_PROPOSED_ASSETS";
export const SET_IS_ASSET_CREATED_OR_EDITED = "SET_IS_ASSET_CREATED_OR_EDITED";
export const SET_PROPOSED_ASSET_MARKERS = "SET_PROPOSED_ASSET_MARKERS";
export const SET_PROPOSED_ASSETS_PARAMS = "SET_PROPOSED_ASSETS_PARAMS";
export const SET_ASSETS_PARAMS = "SET_ASSETS_PARAMS";
export const SET_SELECTED_ASSET_CONFIG_ID = "SET_SELECTED_ASSET_CONFIG_ID";
export const SET_SELECTED_ASSET_IDS = "SET_SELECTED_ASSET_IDS";
export const SET_SELECTED_POLYGON_ASSET_IDS = "SET_SELECTED_POLYGON_ASSET_IDS";
export const SET_SELECTED_ROW_IDS = "SET_SELECTED_ROW_IDS";
export const SHOW_ASSET_LIST_VIEW = "SHOW_ASSET_LIST_VIEW";
export const SHOW_EXISTING_ASSET_LIST_VIEW = "SHOW_EXISTING_ASSET_LIST_VIEW";
export const SHOW_EXISTING_SUB_ASSET_LIST_VIEW = "SHOW_EXISTING_SUB_ASSET_LIST_VIEW";
export const STORE_GEOSERVER_ASSETS_DATA = "STORE_GEOSERVER_ASSETS_DATA";
export const STORE_PROPOSED_ASSETS = "STORE_PROPOSED_ASSETS";
export const STORE_ASSETS = "STORE_ASSETS";
export const SET_SELECTED_SUB_ASSETS = "SET_SELECTED_SUB_ASSETS";
export const STORE_REAL_TIME_POLYGON_DATA = "STORE_REAL_TIME_POLYGON_DATA";
export const TOGGLE_CREATE_POLYGON_ASSET_PANEL = "TOGGLE_CREATE_POLYGON_ASSET_PANEL";
export const TOGGLE_EDIT_ASSET_PANEL = "TOGGLE_EDIT_ASSET_PANEL";
export const TOGGLE_EDIT_POLYGON_ASSET_PANEL = "TOGGLE_EDIT_POLYGON_ASSET_PANEL";
export const STORE_EXISTING_POLYGON_ASSETS_DATA = "STORE_EXISTING_POLYGON_ASSETS_DATA";
export const TOGGLE_ASSET_ACTION_PERFORMED = "TOGGLE_ASSET_ACTION_PERFORMED";
export const SET_SEGMENT_POINT_ASSET_DATA = "SET_SEGMENT_POINT_ASSET_DATA";
/* Edit Asset Types End */
export const IS_ANY_ASSET_PUBLISHED = "IS_ANY_ASSET_PUBLISHED";
export const EDIT_ASSET_DATA_ACTION = "EDIT_ASSET_DATA_ACTION";
export interface StringIndexReturnBoolean {
    [index: string]: boolean;
}

export interface MarkerData {
    clickableText: unknown;
    location: {
        lat: number;
        lng: number;
    };
    icon: string;
    iconWidth: number;
    iconHeight: number;
    id: string;
    selected: boolean;
    assetConfigId: string;
}

export interface MarkerDataInterface {
    [index: string]: MarkerDataObject;
}

export interface MarkerDataObject {
    [index: number]: MarkerData;
}

export interface PointMarkerInterface {
    coordinates: Array<number>;
    eachMarker: MarkerData;
}

export interface APDSProperties {
    Validity: {
        date: {
            end_date: string;
            start_date: string;
        };
        time: {
            end_time: string;
            start_time: string;
        };
        days_of_week: string[];
    };
    parking_types: [
        {
            [index: string]: {
                occupied: number | null;
                applicable: boolean;
                available_spaces: number | null;
            };
        }
    ];
}

export interface AdditionalParkingSpaces {
    [prop: string]: string;
}

export interface SubAssetDetails {
    [prop: string]: string;
}

export interface AssetInterface {
    id: number;
    geom: GeometryPointInterface;
    meta_data: {
        [index: string]: string | APDSProperties | string[] | AdditionalParkingSpaces;
    };
    subasset_details: {
        [index: string]: string | string[] | SubAssetDetails;
    };
    asset_config: number;
    asset_config_id: number;
    selected: boolean;
    visible: boolean;
    APDSProperties?: APDSProperties;
    asset_label?: string;
}

export interface AssetDataInterface extends GetResponseInterface {
    results: Array<AssetInterface>;
}

export interface PolygonAssetInterface {
    id: number;
    geom: EditAssetPayload["geometry"] | GeometryPointInterface | null;
    meta_data: { [index: string]: string };
    asset_config: number;
    asset_config_id: number;
    selected: boolean;
    visible: boolean;
    isNewAsset: boolean;
    has_real_time_data: boolean;
    asset_label?: string;
}

export interface ProposedPolygonAssetDataInterface extends GetResponseInterface {
    results: Array<PolygonAssetInterface>;
}

export interface ExistingPolygonAssetDataInterface extends GetResponseInterface {
    results: ExistingPolygonAssetsData[];
}

export interface AssetConfigInterface {
    show_on_pfcv: boolean;
    id: number;
    asset_type: string;
    asset_title: string;
    icon: string;
    map_icon: string;
    filter_section_name: string;
    display_name: string;
    color: string;
    config: { [index: string]: string };
    is_visible: boolean;
    is_pfcv_selected: boolean;
    type: string;
    has_pay_option: boolean;
    size: number;
    persistent_visibility: boolean;
}

export interface AssetConfigDataInterface extends GetResponseInterface {
    results: Array<AssetConfigInterface>;
}

export interface GetAssetDataAction {
    type: typeof GET_ASSET_DATA;
    payload: { params: GetRequestWithoutLimitOffset };
}

export interface GetAssetConfigDataAction {
    type: typeof GET_ASSET_CONFIG_DATA;
    payload: { params: GetRequestInterface };
}

export interface ReceivedAssetDataAction {
    type: typeof RECEIVED_ASSET_DATA;
    payload: { assetData: AssetDataInterface };
}

export interface ReceivedPolygonAssetDataAction {
    type: typeof RECEIVED_POLYGON_ASSET_DATA;
    payload: { assetData: ProposedPolygonAssetDataInterface | AssetDataInterface };
}

export interface ReceivedDefaultPolygonAssetDataAction {
    type: typeof RECEIVED_DEFAULT_POLYGON_ASSET_DATA;
    payload: { assetData: ProposedPolygonAssetDataInterface | AssetDataInterface };
}

export interface ReceivedSegmentAssetDataAction {
    type: typeof RECEIVED_SEGMENT_ASSET_DATA;
    payload: { assetData: AssetDataInterface };
}

export interface ReceivedAssetConfigDataAction {
    type: typeof RECEIVED_ASSET_CONFIG_DATA;
    payload: { assetConfigData: AssetConfigDataInterface };
}

export interface StoreEnabledAssetIdsAction {
    type: typeof STORE_ENABLED_ASSET_IDS;
    payload: { enabledIds: number[] };
}

export interface SelectedAssetColumnsAction {
    type: typeof SELECTED_ASSET_COLUMNS;
    payload: { selectedColumns: string[] };
}

/* Edit Asset Interfaces Start */

export interface GetProposedAssetsAction {
    type: typeof GET_PROPOSED_ASSETS;
    payload: { params: RequestParamsForProposedAssets };
}

export interface GetAssetsAction {
    type: typeof GET_ASSETS;
    payload: { params: RequestParamsForAssets };
}

export interface storeProposedAssetsAction {
    type: typeof STORE_PROPOSED_ASSETS;
    payload: { params: ProposedAssetsInterface };
}

export interface storeAssetsAction {
    type: typeof STORE_ASSETS;
    payload: { params: AssetListInterface };
}

export interface setSelectedSubAssetsAction {
    type: typeof SET_SELECTED_SUB_ASSETS;
    payload: { selectedSubAssetData: any };
}

export interface setProposedAssetMarkersAction {
    type: typeof SET_PROPOSED_ASSET_MARKERS;
    payload: { params: MarkerDataInterface };
}

export interface GetEditAssetFormDataInterface {
    asset_ids: string[] | string;
    proposed_asset_ids?: string[];
}

export interface EditAssetFormDataInterface {
    [propName: string]: FormValues | string;
}

export interface FormValues {
    [index: string]: boolean | null | string;
}

export interface ProposedMetaData {
    [propName: string]: string;
}

export interface EditAssetPayload {
    action: string;
    asset_config_id: number;
    asset_ids: string[];
    proposed_meta_data: ProposedMetaData;
    scenario_id: number;
    geometry: {
        type: string;
        coordinates: number[][][];
    } | null;
}

export interface CreatedPolygonDataFormat {
    type: string;
    features: onEditFeature | [];
}

export type onEditFeature = [
    {
        geometry: EditAssetPayload["geometry"];
        properties: {};
        type: string;
    }
];

export interface GetEditAssetFormDataAction {
    type: typeof GET_EDIT_ASSET_FORM_DATA;
    payload: { params: GetEditAssetFormDataInterface };
}

export interface EditAssetFormDataReceivedAction {
    type: typeof EDIT_ASSET_FORM_DATA_RECEIVED;
    payload: { formData: EditAssetFormDataInterface };
}

export type IsEditAssetPanelOpen = boolean;
export type IsEditPolygonAssetPanelOpen = boolean;

export interface PostEditAssetDataAction {
    type: typeof POST_EDIT_ASSET_DATA;
    payload: { formData: EditAssetPayload; afterSuccess: () => void };
}

export interface EditAssetDataAction {
    type: typeof EDIT_ASSET_DATA_ACTION;
    payload: {
        geom: {
            type: string;
            coordinates: [number, number];
        };
        created: string;
        asset_config: number;
        id: number;
        has_real_time_data: boolean;
        assetid: number;
        modified: string;
        meta_data: {
            Stat1: string;
            Stat2: string;
            Stat3: string;
            Action1: string;
            Action2: string;
            AssetDesc: string;
            AssetName: string;
            "Header Stat": number;
        };
    }[];
}
export interface SetSelectedAssetIdsAction {
    type: typeof SET_SELECTED_ASSET_IDS;
    payload: { selectedIds: string[] };
}

export interface SetSelectedPolygonAssetIdsAction {
    type: typeof SET_SELECTED_POLYGON_ASSET_IDS;
    payload: { selectedPolygonIds: string[] };
}

export interface ToggleEditAssetPanelAction {
    type: typeof TOGGLE_EDIT_ASSET_PANEL;
    payload: { isEditAssetPanelOpen: IsEditAssetPanelOpen };
}

export interface ToggleEditPolygonAssetPanelAction {
    type: typeof TOGGLE_EDIT_POLYGON_ASSET_PANEL;
    payload: { isEditPolygonAssetPanelOpen: IsEditPolygonAssetPanelOpen };
}

export interface ToggleCreatePolygonAssetPanelAction {
    type: typeof TOGGLE_CREATE_POLYGON_ASSET_PANEL;
    payload: { isCreatePolygonAssetPanelOpen: boolean };
}

export interface AssetListViewAttributesReceivedAction {
    type: typeof ASSET_LIST_VIEW_ATTRIBUTES_RECEIVED;
    payload: { data: any };
}

export interface SetProposedAssetsParamsAction {
    type: typeof SET_PROPOSED_ASSETS_PARAMS;
    payload: { data: any };
}

export interface SetAssetsParamsAction {
    type: typeof SET_ASSETS_PARAMS;
    payload: { data: any };
}

export interface ShowAssetListViewAction {
    type: typeof SHOW_ASSET_LIST_VIEW;
    payload: { show: boolean };
}

export interface ShowExistingAssetListViewAction {
    type: typeof SHOW_EXISTING_ASSET_LIST_VIEW;
    payload: { show: boolean };
}

export interface ShowExistingSubAssetListViewAction {
    type: typeof SHOW_EXISTING_SUB_ASSET_LIST_VIEW;
    payload: { show: boolean };
}

export interface SetIsAssetCreatedOrEditedAction {
    type: typeof SET_IS_ASSET_CREATED_OR_EDITED;
    payload: { assetAction: AssetActionInterface };
}

export interface SetSelectedRowIdsAction {
    type: typeof SET_SELECTED_ROW_IDS;
    payload: { selectedRowIds: string[] | any };
}

export interface PublishProposedAssetsAction {
    type: typeof PUBLISH_PROPOSED_ASSETS;
    payload: { selectedRowIds: any; afterPublish: () => void };
}

export interface DeleteProposedAssetsAction {
    type: typeof DELETE_PROPOSED_ASSETS;
    payload: { selectedRowIds: any; afterDelete: () => void };
}

export interface StoreGeoserverAssetsDataAction {
    type: typeof STORE_GEOSERVER_ASSETS_DATA;
    payload: { geoserverAssetsData: GeoserverAssetRootObject };
}

export interface SetSelectedAssetConfigIdAction {
    type: typeof SET_SELECTED_ASSET_CONFIG_ID;
    payload: { selectedAssetConfigId: string };
}

export interface StoreExistingPolygonAssetsDataAction {
    type: typeof STORE_EXISTING_POLYGON_ASSETS_DATA;
    payload: { existingPolygonAssetsData: ExistingPolygonAssetsData[] };
}

export interface SetIsAnyAssetPublishedAction {
    type: typeof IS_ANY_ASSET_PUBLISHED;
    payload: { isAnyAssetPublished: boolean };
}

export interface RequestParamsForProposedAssets {
    fields: string;
    ordering?: string;
    [propName: string]: string | undefined | number | boolean | string[];
}

export interface RequestParamsForAssets {
    fields: string;
    ordering?: string;
    [propName: string]: string | undefined | number | boolean | string[];
}

export interface AssetListInterface {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: {
        id: number;
        geom: GeometryPointInterface;
        meta_data: {
            [index: string]: string | APDSProperties | string[] | AdditionalParkingSpaces;
        };
        sub_asset_restrictions: {
            [index: string]: string | string[] | SubAssetDetails;
        };
        asset_config: number;
        asset_config_id: number;
        selected: boolean;
        visible: boolean;
    }[];
}

export interface ProposedAssetsInterface {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: {
        asset_config: AssetConfigInterface;
        assets: AssetInterface[];
        id: number;
        proposed_meta_data: ProposedMetaData;
        scenario: Scenario;
        geometry: EditAssetPayload["geometry"] | null;
    }[];
}

export interface AssetActionInterface {
    isAssetCreatedOrEdited: boolean;
    assetType: string;
}

/* Edit Asset Interfaces End*/

export interface StoreRealTimePolygonDataAction {
    type: typeof STORE_REAL_TIME_POLYGON_DATA;
    payload: { realTimePolygonData: RealTimePolygonData[] };
}

export interface RealTimePolygonData extends PolygonAssetInterface {}

export interface RealTimePolygonAdditionalData extends RealTimePolygonData {
    fillColor: string;
    borderLineColor: string;
}

export interface ExistingPolygonAssetsData extends PolygonAssetInterface {
    isExistingAsset: boolean;
}

export interface SegmentPointAssetDataType {
    [props: string]: object | null | undefined;
}

export interface SetSegmentPointAssetDataAction {
    type: typeof SET_SEGMENT_POINT_ASSET_DATA;
    payload: {
        data: SegmentPointAssetDataType;
    };
}

export interface ToggleAssetActionPerformedAction {
    type: typeof TOGGLE_ASSET_ACTION_PERFORMED;
}

export interface AssetDataStateInterface {
    assetAction: AssetActionInterface;
    assetConfigData: AssetConfigDataInterface;
    assetData: AssetDataInterface;
    assetListViewAttributes: any;
    editAssetFormData: EditAssetFormDataInterface;
    segmentPointAssets: SegmentPointAssetDataType;
    geoserverAssetsData: GeoserverAssetRootObject;
    isCreatePolygonAssetPanelOpen: boolean;
    isEditAssetPanelOpen: IsEditAssetPanelOpen;
    isEditPolygonAssetPanelOpen: boolean;
    polygonAssetData:
        | ProposedPolygonAssetDataInterface
        | AssetDataInterface
        | ExistingPolygonAssetDataInterface;
    defaultPolygonAssetData:
        | ProposedPolygonAssetDataInterface
        | AssetDataInterface
        | ExistingPolygonAssetDataInterface;
    existingPolygonAssetsData: ExistingPolygonAssetsData[];
    proposedAssetMarkers: MarkerDataInterface;
    proposedAssets: ProposedAssetsInterface;
    assets: AssetListInterface;
    isAllProposedAssetsFetching: boolean;
    isAllAssetsFetching: boolean;
    proposedAssetsParams: any;
    AssetsParams: any;
    segmentAssetData: AssetDataInterface;
    selectedAssetConfigId: string;
    selectedAssetIds: string[];
    selectedPolygonAssetIds: string[];
    selectedRowIds: any;
    showAssetListView: boolean;
    showExistingAssetListView: boolean;
    showExistingSubAssetListView: boolean;
    realTimePolygonData: RealTimePolygonData[];
    isAnyAssetPublished: boolean;
    assetActionPerformed: boolean;
    enabledIds: number[];
    editAssetData: EditAssetDataAction["payload"];
    selectedColumns: string[];
    selectedSubAssetData: any;
}

export type AssetDataTypes =
    | AssetListViewAttributesReceivedAction
    | DeleteProposedAssetsAction
    | EditAssetFormDataReceivedAction
    | GetAssetConfigDataAction
    | GetAssetDataAction
    | GetEditAssetFormDataAction
    | GetProposedAssetsAction
    | GetAssetsAction
    | PostEditAssetDataAction
    | PublishProposedAssetsAction
    | ReceivedAssetConfigDataAction
    | ReceivedAssetDataAction
    | ReceivedPolygonAssetDataAction
    | ReceivedSegmentAssetDataAction
    | SetSegmentPointAssetDataAction
    | SelectedAssetColumnsAction
    | SetIsAnyAssetPublishedAction
    | SetIsAssetCreatedOrEditedAction
    | setProposedAssetMarkersAction
    | SetProposedAssetsParamsAction
    | SetAssetsParamsAction
    | SetSelectedAssetConfigIdAction
    | SetSelectedAssetIdsAction
    | SetSelectedPolygonAssetIdsAction
    | SetSelectedRowIdsAction
    | ShowAssetListViewAction
    | StoreExistingPolygonAssetsDataAction
    | StoreGeoserverAssetsDataAction
    | storeProposedAssetsAction
    | storeAssetsAction
    | StoreRealTimePolygonDataAction
    | ToggleCreatePolygonAssetPanelAction
    | ToggleEditAssetPanelAction
    | ToggleEditPolygonAssetPanelAction
    | ToggleAssetActionPerformedAction
    | ResetStateAction;
